import toast from 'react-hot-toast';

const baseStyle = {
    borderRadius: '8px',
    fontSize: '14px',
    maxWidth: '400px',
};

const notify = {
    success: (message, options = {}) =>
        toast.success(message, {
            duration: 5000,
            style: {
                ...baseStyle,
                background: '#ecfdf5',
                color: '#065f46',
                border: '1px solid #6ee7b7',
            },
            iconTheme: {
                primary: '#10b981',
                secondary: '#ecfdf5',
            },
            ...options,
        }),

    error: (message, options = {}) =>
        toast.error(message, {
            duration: 5000,
            style: {
                ...baseStyle,
                background: '#fef2f2',
                color: '#991b1b',
                border: '1px solid #fca5a5',
            },
            iconTheme: {
                primary: '#ef4444',
                secondary: '#fef2f2',
            },
            ...options,
        }),

    warning: (message, options = {}) =>
        toast(message, {
            duration: 5000,
            icon: '⚠️',
            style: {
                ...baseStyle,
                background: '#fffbeb',
                color: '#92400e',
                border: '1px solid #fcd34d',
            },
            ...options,
        }),

    info: (message, options = {}) =>
        toast(message, {
            duration: 5000,
            icon: 'ℹ️',
            style: {
                ...baseStyle,
                background: '#eff6ff',
                color: '#1e40af',
                border: '1px solid #93c5fd',
            },
            ...options,
        }),

    loading: (message, options = {}) =>
        toast.loading(message, {
            style: {
                ...baseStyle,
                background: '#f8fafc',
                color: '#334155',
                border: '1px solid #cbd5e1',
            },
            ...options,
        }),

    dismiss: (toastId) => toast.dismiss(toastId),

    promise: (promise, messages = {}, options = {}) =>
        toast.promise(
            promise,
            {
                loading: messages.loading ?? 'Cargando...',
                success: messages.success ?? 'Operación exitosa',
                error:   messages.error   ?? 'Ocurrió un error',
            },
            {
                style: baseStyle,
                ...options,
            }
        ),
};

export default notify;
